var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFibeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90499 26.6229C7.45052 26.6229 9.51408 24.6691 9.51408 22.2589C9.51408 19.8488 7.45052 17.895 4.90499 17.895C2.35946 17.895 0.295898 19.8488 0.295898 22.2589C0.295898 24.6691 2.35946 26.6229 4.90499 26.6229Z",
    fill: "#F8A63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3719 16.3585C19.6346 16.3585 21.4688 14.6218 21.4688 12.4794C21.4688 10.3371 19.6346 8.6004 17.3719 8.6004C15.1092 8.6004 13.2749 10.3371 13.2749 12.4794C13.2749 14.6218 15.1092 16.3585 17.3719 16.3585Z",
    fill: "#079F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69178 7.22215C6.67164 7.22215 8.27663 5.70254 8.27663 3.828C8.27663 1.95345 6.67164 0.433838 4.69178 0.433838C2.71193 0.433838 1.10693 1.95345 1.10693 3.828C1.10693 5.70254 2.71193 7.22215 4.69178 7.22215Z",
    fill: "#FF3E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibeIcon);
export default __webpack_public_path__ + "static/media/Fibe_Icon.475cde1d3fa45bae4a7b772ebf7d9cca.svg";
export { ForwardRef as ReactComponent };